import { useMutation } from "@apollo/client";
import {
  EditMessageThreadIsLockedMutation,
  EditMessageThreadIsLockedMutationVariables,
} from "gql/graphql";
import EDIT_MESSAGE_THREAD_IS_LOCKED_MUTATION from "modules/messaging/_networking/edit-message-thread-is-locked";
import { useAuth } from "modules/providers/auth-provider";

const useEditMessageThreadIsLocked = (id: string, isLocked: boolean) => {
  const { me } = useAuth();

  return useMutation<
    EditMessageThreadIsLockedMutation,
    EditMessageThreadIsLockedMutationVariables
  >(EDIT_MESSAGE_THREAD_IS_LOCKED_MUTATION, {
    variables: {
      id,
      isLocked,
    },
    optimisticResponse: {
      editMessageThread: {
        __typename: "MessageThread",
        id,
        isLocked,
        lockedUserId: isLocked ? me?.id : undefined,
      },
    },
  });
};

export default useEditMessageThreadIsLocked;
